import { useContext } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Hero from "../components/Hero";
import TrustStrip from "../components/TrustStrip";
import Intro from "../components/Intro";
import Rooms from "../components/Rooms";
import Breakfast from "../components/Breakfast";
import Trust from "../components/Trust";
import { LanguageContext } from "../App";

export default function HomePage() {
  const { t } = useContext(LanguageContext);

  return (
    <>
      <Hero />
      <TrustStrip />
      <Intro />

      {/* Rooms preview — links to /camere */}
      <Rooms showBooking={false} />

      {/* Breakfast storytelling */}
      <Breakfast />

      {/* CTA Banner → /prenota */}
      <section
        data-testid="home-cta-banner"
        className="bg-[#2A2726] py-20 md:py-28 px-6 text-center"
      >
        <div className="max-w-2xl mx-auto">
          <motion.p
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.7 }}
            className="font-['Manrope',sans-serif] text-xs uppercase tracking-[0.3em] text-white/40 mb-5"
          >
            {t.contact.cta_overline}
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.9, delay: 0.1 }}
            className="font-['Cormorant_Garamond',serif] text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-white tracking-tight mb-5"
          >
            {t.contact.cta_headline}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }}
            className="font-['Manrope',sans-serif] text-sm text-white/50 mb-10"
          >
            {t.contact.cta_text}
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.3 }}
          >
            <Link
              to="/prenota"
              data-testid="home-prenota-btn"
              className="inline-flex items-center justify-center bg-[#FDFBF7] text-[#2A2726] font-['Manrope',sans-serif] text-xs uppercase tracking-[0.25em] w-full sm:w-auto px-12 py-5 hover:bg-[#F5F1EA] transition-all duration-300"
            >
              {t.contact.cta_button}
            </Link>
          </motion.div>
        </div>
      </section>

      <Trust />
    </>
  );
}
